import {Footer} from '@/components/ui/footer';
import {Navbar} from '@/components/ui/navbar';
import {Outlet, createFileRoute, redirect} from '@tanstack/react-router';

export const Route = createFileRoute('/blog')({
  component: BlogLayout,
  beforeLoad: ({context}) => {
    if (!context.featureFlags['enable-blog']) {
      throw redirect({to: '/'});
    }
  },
});

/** Layout route for public blog pages. Gates access behind the enable-blog feature flag. */
function BlogLayout() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
